export class TrendMetric {
    public static readonly COLOR_COUNT = 5;
    public static readonly C_A700 = ['#d50000', '#FF6D00', '#FFD600', '#64DD17', '#00C853'];
    public static readonly C_900 = ['#b71c1c', '#E65100', '#F57F17', '#33691E', '#1B5E20'];
    public static readonly C_300 = ['#e57373', '#FFB74D', '#FFF176', '#AED581', '#81C784'];

    initialized = false;
    metricType: string;
    tileType: string;
    name: string;
    currency: string;
    currencyIndex: number;

    public static toTileKey(currency: string, metricType: string) {
        return currency + '.' + metricType;
    }
    constructor(metricType: string, tileType: string) {
        this.metricType = metricType;
        this.tileType = tileType;
    }

    createTileKey(): string {
        return TrendMetric.toTileKey(this.currency, this.metricType);
    }


}
